// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__7lVeE","title":"styles_title__EukGF","ratioList":"styles_ratioList__QVuGI"};